
import { IEnterpriseItem, IRoleOptionsItem } from '../../types/common';
import { IAddEnterpriseUsers, IEnterpriseUsersParam, ICompanyUsers, ICompanyPermission, IUpdateCompanyPermission } from '../../types/user-center/enterprise';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 用户中心 - 企业用户数据查询
 */
export async function queryEnterpriseUsers(param: IEnterpriseUsersParam) {
  let data = [] as ICompanyUsers[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IEnterpriseUsersParam;

  try {
    const { code, context, message } = await Http.post<{ data: ICompanyUsers[]; total: number }>(`${hostUrl}/iam/identity/company/list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: ICompanyUsers[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}

/**
 * 用户中心 - 企业用户 - 新增用户
 */
export async function addEnterpriseUsers(param: IAddEnterpriseUsers) {
  let data = {} as { warnCode: number; extra: { name: string }};

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/iam/identity/company`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 企业用户 - 角色列表
 */
export async function queryCompanyRoleList(companyId?: number, isDisplay?: boolean) {
  let data = [] as IRoleOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IRoleOptionsItem>>(`${hostUrl}/iam/role/company/list`, {
      companyId,
      isDisplay,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 企业用户 - 查询用户详情
 */
export async function queryCompanyAuth(identityId: number) {
  let data = {} as ICompanyPermission;

  try {
    const { code, context, message } = await Http.get<ICompanyPermission>(`${hostUrl}/iam/identity/company/auth`, { identityId });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}

/**
 * 用户中心 - 企业用户 - 更新数据权限
 */
export async function updateCompanyAuth(params: IUpdateCompanyPermission) {

  try {
    const { code, message } = await Http.put<IUpdateCompanyPermission>(`${hostUrl}/iam/identity/company/auth`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 用户中心 - 企业用户 - 修改权限 - 企业列表
 */
export async function queryCompanyAuthList() {
  let data = [] as IEnterpriseItem[];

  try {
    const { code, context, message } = await Http.post<Array<IEnterpriseItem>>(`${hostUrl}/side/company/list-sub`);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}